import React, { useState } from 'react';
//==================Components==================//
import { Dashboard as DashboardLayout } from 'layouts';
import { AccountDetails, AccountProfile } from './components';
//==================Externals==================//
import classNames from 'classnames';
//==================Styles==================//
import { Grid2 } from '@mui/material';
import styles from './styles';
import { makeStyles } from '@mui/styles';
import UserEditable from './components/UserEditable';
import { useSelector } from 'react-redux';
const useStyles = makeStyles(styles);

export default function Account() {
  const classes = useStyles();
  const rootClassName = classNames(classes.root);
  const [updateUser, setUpdateUser] = useState(false);
  const user = useSelector((state) => state.user.user);

  return (
    <DashboardLayout title="Mi cuenta">
      <div className={rootClassName}>
        <Grid2 container={true} spacing={4}>
          <Grid2 size={{ xl: 4, lg: 4, md: 6, xs: 12 }}>
            <AccountProfile />
          </Grid2>
          <Grid2 size={{ xl: 8, lg: 8, md: 6, xs: 12 }}>
            <AccountDetails setUpdateUser={setUpdateUser} user={user} />
          </Grid2>
        </Grid2>
        <UserEditable open={updateUser} setOpen={setUpdateUser} user={user} />
      </div>
    </DashboardLayout>
  );
}
